import styled, { css } from 'styled-components';

export const ReportItemLi = styled.li`
    display: flex;
    justify-content: space-between;
`;
export const ReportVariant = styled.div`
    display: flex;
    align-items: center;
    gap: 3.41px;
    justify-content: space-between;
    font-weight: 600;
    @media (max-width: 425px) {
        gap: 8px;
    }
`;
export const ColorChip = styled.div`
    width: 8.515752792358398px;
    height: 8.515752792358398px;
    opacity: 1;
    border-radius: 3.41px;
    ${(props) =>
        props.$id === 'heart' &&
        css`
            background-color: #ff3388;
        `}
    ${(props) =>
        props.$id === 'groupPurchase' &&
        css`
            background-color: #ff7638;
        `}
    ${(props) =>
        props.$id === 'phone79' &&
        css`
            background-color: #11d70d;
        `}
    ${(props) =>
        props.$id === 'maintenance' &&
        css`
            background-color: #3385ff;
        `}
        ${(props) =>
        props.$id === 'refunds' &&
        css`
            background-color: #ad33ff;
        `} 
        ${(props) =>
        props.$id === 'point' &&
        css`
            background-color: #ff3333;
        `}
`;
export const DiffValue = styled.span`
    color: #757575;
    font-weight: 500;
    ${(props) =>
        props.$id === 'total' &&
        css`
            font-weight: 600;
            color: #000000;
        `}
`;
